import { render, staticRenderFns } from "./VesselType.vue?vue&type=template&id=9e318ade"
import script from "./VesselType.vue?vue&type=script&lang=js"
export * from "./VesselType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports